import MuiButton from "./components/Button";
import MuiContainer from "./components/Container";
import MuiDrawer from "./components/Drawer";
import MuiMenu from "./components/Menu";
import MuiSkeleton from "./components/Skeleton";
import MuiTableContainer from "./components/Table";
import MuiTabs from "./components/Tab";
import MuiTextField from "./components/TextField";
import MuiBaseLine from "./components/MuiBaseLine";

const components = {
  MuiButton,
  MuiSkeleton,
  MuiMenu,
  MuiTableContainer,
  MuiTextField,
  MuiTabs,
  MuiContainer,
  MuiDrawer,
  MuiBaseLine,
};

export default components;
